import { TRACKING_CURRENCY } from '../../const';

export const cartShippingModel = (action: any) => {
  const isWithdrawal = action.meta.payload?.iswithdrawal || action.meta.payload?.isWithdrawal;

  return {
    event: 'add_shipping_info',
    ecommerce: {
      currency: TRACKING_CURRENCY,
      value: 0,
      shipping_tier: isWithdrawal ? 'retirar' : 'receber',
      items: [],
    },
  };
};
